import {IVanillaReaderSyntheticPageListData} from "./VanillaReaderModel";
import {IReaderViewAnnotationLayer} from "@colibrio/colibrio-reader-framework/colibrio-readingsystem-base";
import {VanillaReaderView} from "./VanillaReaderView";
import {LocatorFactory} from "@colibrio/colibrio-reader-framework/colibrio-core-locator";

export class VanillaReaderAnnotationLayerPageMarkers {
    private _annotationLayer: IReaderViewAnnotationLayer;
    private _pageNumberSvgTemplate = "%3C%3Fxml version='1.0' encoding='UTF-8' standalone='no'%3F%3E%3Csvg width='100%25' preserveAspectRatio='xMinYMin meet' viewBox='0 0 5.7149889 2.5929101' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:svg='http://www.w3.org/2000/svg'%3E%3Ctext xml:space='preserve' style='font-weight:bold%3Bfont-size:11px%3Bline-height:1%3Bfont-family:sans-serif%3Bfill:{{page_number_color}}' transform='matrix(0.06683661 0 0 0.06683661 0.13437553 1)'%3E%3Ctspan%3E{{page_number}}%3C/tspan%3E%3C/text%3E%3C/svg%3E";
    constructor(private vanillaReaderView: VanillaReaderView, private _pageList: IVanillaReaderSyntheticPageListData) {
        this._annotationLayer = this.vanillaReaderView.colibrioReaderView.createAnnotationLayer('vanilla-reader__synthetic-page-range-layer');
        this._annotationLayer.setLayerOptions({
            annotationInputEngineEventsEnabled: false,
            layerClassName: 'vanilla-reader__synthetic-page-range-layer'
        })
        this._annotationLayer.setVisible(false);
        this._populate();
    }

    public get isVisible(): boolean {
        return this._annotationLayer.isVisible();
    }

    refresh(): void {
        this._annotationLayer.destroyAllAnnotations();
        this._populate();
    }

    setVisible(visible: boolean): void {
        this._annotationLayer.setVisible(visible);
    }

    /**
     *
     * PRIVATE METHODS
     *
     * */

    private _populate(): void {

        this._pageList.pages.forEach((pageData)=>{
            if(pageData.locatorData) {
                let locatorFactory: LocatorFactory = this.vanillaReaderView.getVanillaReaderPublication().colibrioReaderPublication.getLocatorFactory();
                let locator = locatorFactory.parse(pageData.locatorData).locator;
                if(locator) {
                    let positionLocator = locatorFactory.collapseRangeLocatorToStart(locator);
                    let pageAnnotation = this._annotationLayer.createAnnotation(positionLocator, pageData);
                    let pageNumberBackgroundString = this._pageNumberSvgTemplate.replace('{{page_number}}', pageData.label);
                    let pageMarkerColorValue = this.vanillaReaderView.activePalette?.isDark ?
                        this.vanillaReaderView.activePalette.foregroundLight :
                        this.vanillaReaderView.activePalette?.foregroundDark;


                    let encodedColorValue = pageMarkerColorValue ? pageMarkerColorValue.replace('#', '%23') : 'rgba(0,0,0,0.7)';
                    pageNumberBackgroundString = pageNumberBackgroundString.replace('{{page_number_color}}',  encodedColorValue);

                    pageAnnotation.setOptions({
                        containerClassName: 'vanilla-reader__synthetic-page-range-layer__annotation',
                        containerStyle: {
                            'background-image': `url("data:image/svg+xml,${pageNumberBackgroundString}")`,
                            'background-size': 'contain',
                            'background-repeat': 'no-repeat',
                            'left': '0.4em',
                            'height': '36px',
                            'width': '100%',
                            'opacity': '0.6',
                        }
                    });

                } else {
                    console.warn(`VanillaReaderAnnotationLayerPageRanges._populate, page data has no valid locator.`, pageData);
                }
            }
        });
    }
}
